/**
 * 后台数据传给前端的是原始seq数据，前端需要将其转换成图片数据
 */

//转图像需要时间，采用异步变同步的方式


import $ from 'jquery';


let debugswitch = false;

export async function imgdataConvert(data, buildControl) {

    // 后台返回的数据格式如下：
    // 外层数据格式
    // ret = {
    //     "code": 200,
    //     "uuid": uuidkey,
    //     "idname": uuid,             # 用于前台显示的id
    //     "data": retdata,
    // }
    // data 内层的数据格式
    // msg = {
    //     "version" : "DV1.0.0",
    //     "color" : colorcfg,
    //     "width" : imgwidth,
    //     "height" : imgheight,
    //     "widthchunk" : width_chunk,
    //     "heightchunk" : height_chunk,
    //     "image" : area,
    //     "style" : style
    // }

    
    if ( data.code != 200 )
    {
        return 'error';
    }

    let uuid = data.uuid;
    let idname = data.idname;
    let result = data.data;

    let rebuildimgs = [];
    for (let i = 0; i < result.length; i++) 
    {
        let seqimgdata = result[i];
        let imgurl = await buildControl.convert(seqimgdata, 8);
        // let bigimgurl = await buildControl.convert(seqimgdata, 60, true);

        // console.log('seq is ' + i);
        // console.dir(imgurl);
        let stylename = seqimgdata.style;

        // 根据返回的序列图数据，生成图片，并且将图片和序列图数据封装，再一起返回
        let retdata = {
            smallimg : imgurl,
            seqdata : seqimgdata,
            id : idname,
            style : stylename,
            like : false,               // 是否点赞
            unlike : false,             // 是否踩
        }

        rebuildimgs.push(retdata);
    }
    
    return rebuildimgs;

}


// export var MpdScene = function (domElement, ops) {
    var helped = false;//提示框只弹一次
    export var Build = (function (window) {
    var clickCount = 0; //快速点击次数
    //构造函数    
    var Build = function (options) {
        var self = this;
        this.buildIndex = 0;//当前拼装的部位索引
        this.buildComplete = false; //是否拼装完成
        this.minimapContainer = options.minimapContainer//指示图容器
        this.partContainer = options.partContainer;//单部位画布
        this.nextBut = options.nextBut;//下一步按钮
        this.prevBut = options.prevBut;//上一步按钮
        this.minimapParticelSize = options.minimapParticelSize;//小地图颗粒大小
        this.clickAlert = options.clickAlert;//点击小地图提示 
        this.effectImg = null;//效果图,用于显示拼装效果,明确申明,不动态添加,避免出错
        this.pixelData = null;//像素数据
        this.effect_id = null;//生成的效果图id
        this.board_width = options.board_width;  //多底板的情况下，默认一块底板的宽度
        this.board_height = options.board_height; //多底板的情况下，默认一块底板的高度
        this.draw_edge_inlittleArea = options.draw_edge_inlittleArea;   // 在小区域内绘制边框,比如钻石画的小区域，内部是白色，而边框是灰色的
        //初始化基础颗粒图，是全局变量
        particelObj.init(options.whiteParticel, options.blackParticel);
        //绑定事件 
        if (this.nextBut != undefined && this.prevBut != undefined) {
            this.nextBut.onclick = function (event) { self.nextPart(); event.preventDefault(); };
            this.prevBut.onclick = function (event) { self.prevPart(); event.preventDefault(); };
        }
        //对外事件
        this.onUpdateImage = options.onUpdateImage !== undefined ? options.onUpdateImage : null;
        this.onBuildCompleted = options.onBuildCompleted !== undefined ? options.onBuildCompleted : null;
        //监听当前索引的变化
        Object.defineProperty(self, "buildIndex", {
            get: () => { return this._buildIndex },
            set: function (value) {
                this._buildIndex = value;
                //更新按钮的显示
                var prevBut = this.prevBut;
                var nextBut = this.nextBut;
                if (value == 0) {
                    $(prevBut).addClass("disabled");
                    if ($(nextBut).hasClass("disabled")) {
                        $(nextBut).removeClass("disabled");
                    }
                }
                else if (value == this.pixelData.image.length - 1) {
                    $(nextBut).addClass("disabled");
                    if ($(prevBut).hasClass("disabled")) {
                        $(prevBut).removeClass("disabled");
                    }
                }
                else {
                    if ($(nextBut).hasClass("disabled")) {
                        $(nextBut).removeClass("disabled");
                    }
                    if ($(prevBut).hasClass("disabled")) {
                        $(prevBut).removeClass("disabled");
                    }
                }
                //更新显示坐标
                var Xaxis, Yaxis;
                var x = value % this.pixelData.widthchunk;
                var y = Math.floor(value / this.pixelData.widthchunk);
                if (this.pixelData.widthchunk > this.pixelData.heightchunk) {
                    Xaxis = String.fromCharCode(65 + y);
                    Yaxis = x + 1;
                }
                else {
                    Xaxis = String.fromCharCode(65 + x);
                    Yaxis = y + 1;
                }
                //console.log("Xaxis: "+Xaxis+",Yaxis: "+Yaxis);
            }
        })

    }

    // 设置当前产品的配置数据
    Build.prototype.setProductCfg = function (board_width, board_height) {
        this.pixelData.board_width = board_width;
        this.pixelData.board_height = board_height;
    }


    //设置图像数据
    Build.prototype.setImage = async function (originalImage, effectImg, pixelData) {
        if (pixelData != undefined) {
            this.originalImage = originalImage;
            this.effectImg = effectImg;
            this.pixelData = pixelData;
            this.buildIndex = 0;
            //将数据进行格式化
            await formatPixelData(pixelData);
            if (typeof this.onUpdateImage === "function") {
                this.onUpdateImage(this);
            }
        }
    }
    //开始构建
    Build.prototype.startBuild = function () {

        miniMap.init(this.minimapContainer, this);
        aniObj.init(this.partContainer, this);
        // test_aniobj.init(this.partContainer);
    }
    //下一步
    Build.prototype.nextPart = function () {
        if (aniObj.isplaying == false) {
            if (this.buildIndex < this.pixelData.image.length - 1) {
                this.buildIndex = getButIndex(this, true);
                this.drawMinimapImage();
                aniObj.play("next");
                if (this.buildComplete == false && this.buildIndex == this.pixelData.image.length - 1) {
                    //拼装完成
                    this.buildComplete = true;
                    if (typeof this.onBuildCompleted === "function") {
                        this.onBuildCompleted();
                    }
                }
            }
        }
        else {
            //弹出提示框
            if (!helped) {
                clickCount++;
                if (clickCount > 2) {
                    this.clickAlert.show();
                    helped = true;
                }
            }
        }
    }
    //上一步
    Build.prototype.prevPart = function () {
        if (aniObj.isplaying == false) {
            if (this.buildIndex > 0) {
                this.buildIndex = getButIndex(this, false);
                this.drawMinimapImage();
                aniObj.play("prev");
            }

        }
        else {
            //弹出提示框
            if (!helped) {
                clickCount++;
                if (clickCount > 2) {
                    this.clickAlert.show();
                    helped = true;
                }
            }
        }
    }
    //绘制小地图
    Build.prototype.drawMinimapImage = function (index) {
        // var byStep = true;
        var byStep = false;
        if (index != undefined) {
            this.buildIndex = index;
            byStep = false;
        }

        miniMap.drawImg(this, this.pixelData, this.buildIndex, byStep);
    }

    /**
     * 将数据转换为图片
     * @param {*像素画数据} data 
     * @param {*生成图片颗粒像素大小} particleSize 
     * @param {*部位分割线宽度} prominent 
     */
    Build.prototype.convert = async function (data, particleSize, prominent) {
        var canvas = document.createElement('canvas');
        var cxt = canvas.getContext("2d");
        //调整画布大小            
        canvas.width = particleSize * data.width;
        canvas.height = particleSize * data.height;
        var brush = {
            cxt: cxt,
            size: particleSize,
        }
        await particelObj.createImgForData(data);
        for (var i = 0; i < data.image.length; i++) {
            drawPart(this, { colorIndexs: data.image[i], colorMap: data.color }, brush, { isChild: true, prominent: prominent });
        }
        var url = canvas.toDataURL();
        return url;
    }


    // Build的清理操作
    Build.prototype.clear = function () {
        
        this.originalImage = null;
        this.effectImg = null;
        this.pixelData = null;
        
        // 由于particelObj是全局变量，所以清理的时候要将其中的img对象清理掉，否则下次再使用时会出现错误
        for (var i = 0; i < particelObj.particelImgs.length; i++) {
            particelObj.particelImgs[i].img.src = '';
            particelObj.particelImgs[i].img = null;
        }
        particelObj.particelImgs = [];

    }


    //绘制一个部位
    var drawPart = function (buildControl, partData, brush, options) {
        var isChild = options.isChild !== undefined ? options.isChild : false;//是否作为图片子部位
        var mask = options.mask !== undefined ? options.mask : false;//是否需要遮罩遮挡
        var prominent = options.prominent !== undefined ? options.prominent : false;//是否突出显示
        var part = partData.colorIndexs; //像素索引
        var colorMap = partData.colorMap; //映射表
        var xCount = part.width; //横向颗粒数 
        var yCount = part.height;//纵向颗粒数        
        var startx = 0;  //起始位置x
        var starty = 0;  //起始位置y
        if (isChild) {
            //如果作为整张图片的一部分
            startx = part.startx;
            starty = part.starty;
        }

        if (debugswitch == true)
        {
            // 如下既有调试信息，也有功能代码，调试时请注意
            console.log("drawPart startx %d starty %d, data length %d, part x %d y %d, build index %d," +
                        " brush size %d, xcount %d, ycount %d", 
                   startx, starty, part.data.length, part.startx, part.starty, buildControl.buildIndex, brush.size, xCount, yCount);
            console.dir(colorMap);
            brush.cxt.fillStyle = 'rgba(30, 30, 30, 1)'
            brush.cxt.fillRect(startx * brush.size, starty * brush.size, xCount * brush.size, yCount * brush.size);
            brush.cxt.strokeRect(startx * brush.size, starty * brush.size, xCount * brush.size, yCount * brush.size);
        }
        
        
       
        //绘制每一个颗粒
        for (var i = 0; i < part.data.length; i++) {
            //计算位置
            var xIndex = i % xCount;
            var yIndex = parseInt(i / xCount);
            var posx = (startx + xIndex) * brush.size;
            var posy = (starty + yIndex) * brush.size;
            //找到对应的颜色颗粒
            var item = colorMap.find(function (item) { return item.seq == part.data[i] });

            // console.log('drawPart i %d item', i);
            // console.dir(item);


            // console.log('drawPart---- i %d item', i, " edge in little area ", buildControl.draw_edge_inlittleArea);


            //先清空像素（也就是用底色填充，相当于底板的颜色）
            brush.cxt.fillStyle = 'rgba(50, 50, 50, 0.8)'                 //深色底，黑底
            if (buildControl.draw_edge_inlittleArea == true && isChild == false)
            {
                if ((xIndex == 0 || yIndex == 0 || xIndex == xCount - 1 || yIndex == yCount - 1)) {
                    brush.cxt.fillStyle = 'rgba(150, 150, 150, 1)'
                }
                else {
                    brush.cxt.fillStyle = 'rgba(240, 240, 240, 1)'
                }
            }

            // brush.cxt.fillStyle = 'rgba(255, 255, 255, 1)'                 //白色底，白底
            brush.cxt.clearRect(posx, posy, brush.size, brush.size);
            brush.cxt.fillRect(posx, posy, brush.size, brush.size);
            //用颗粒图片填充
            if (item) {
                // console.log('drawPart---- i %d item', i);
                // console.dir(item);
                //绘制颗粒
                brush.cxt.drawImage(item.img, posx, posy, brush.size, brush.size);
                //再绘制编号(小于5像素，不绘制)
                // var fontSize = brush.size * 2 / 5;
                if (typeof(item.attribute) === 'undefined' || 
                    (typeof(item.attribute) !== 'undefined' && 
                     (item.attribute != 'backgroud' && item.attribute != 'border' )))
                {
                    var fontSize = brush.size * 6 / 10;
                    if (fontSize > 5) {
                        brush.cxt.font = fontSize + "px 隶书";
                        brush.cxt.fillStyle = 'rgb(' + item.fontRgb[0] + ',' + item.fontRgb[1] + ',' + item.fontRgb[2] + ')';
                        brush.cxt.textAlign = "center";
                        brush.cxt.textBaseline = "middle";
                        brush.cxt.fillText(item.seq, posx + brush.size / 2, posy + brush.size / 2);
                    }
                }
            }
            else {
                // 如果没有对应的颜色索引，说明是背景，前端用灰色（近白色）填充,背景颜色写死
                brush.cxt.fillStyle = 'rgba(220, 220, 220, 0.6)';
                brush.cxt.fillRect(posx, posy, brush.size, brush.size);

                if (!isChild) {
                    brush.cxt.fillStyle = 'rgba(10, 10, 10, 0.6)';
                    brush.cxt.fillRect(posx, posy, brush.size, brush.size);
                    var lineWidth = 1;
                    brush.cxt.strokeStyle = 'rgba(100, 100, 100, 0.6)';
                    brush.cxt.lineWidth = lineWidth;
                    brush.cxt.strokeRect(posx, posy, brush.size, brush.size);
                }

            }
        }

        

        if (mask)
        {
            //填充纯色
            let currentArea = inCurrentArea(buildControl, part.startx, part.starty);
            if (currentArea) {
                brush.cxt.fillStyle = 'rgba(128, 100, 162, 0.6)';
            }
            else {
                brush.cxt.fillStyle = 'rgba(128, 100, 162, 0.65)';
            }
            brush.cxt.fillRect(part.startx * brush.size, part.starty * brush.size, brush.size * xCount, brush.size * yCount);

            if (useMultiBoard(buildControl) == true)
            {
                drawBorder(buildControl, brush, part.startx, part.starty, xCount, yCount);
            }
            
            
        }
        //加描边
        if (prominent) {
            var lineWidth = 2;
            brush.cxt.strokeStyle = "greenyellow";
            brush.cxt.lineWidth = lineWidth;
            brush.cxt.strokeRect(part.startx * brush.size + lineWidth / 2, part.starty * brush.size + lineWidth / 2,
                brush.size * xCount - lineWidth, brush.size * yCount - lineWidth);
        }
    }

    // 绘制底板的边缘和拼接斜角
    function drawBorder(buildControl, brush, startx, starty, xCount, yCount) 
    {
        // 对于拼豆底板，需要绘制边框，边框的宽度29，长度29
        // 先绘制纵向边框
        // 下面的参数，是确定的值，不能随意修改。根据不同的项目，定义不同的参数
        brush.cxt.lineWidth = 1;
        let border_width = buildControl.board_width;
        let border_heiht = buildControl.board_height;
        let show_border_width = 8;
        let show_border_height = 8;

        // 是否绘制斜角
        let draw_angle = false;

        if ((startx + show_border_width) / border_width >= 1 && (startx + 8) % border_width  < show_border_width)
        {
            let border_startx = parseInt((startx + show_border_width) / border_width) * border_width * brush.size;
            let border_starty = starty * brush.size;
            let border_endx = border_startx ;
            let border_endy = (starty + yCount) * brush.size;

            brush.cxt.strokeStyle = 'hotpink';
            brush.cxt.moveTo(border_startx, border_starty);
            brush.cxt.lineTo(border_endx, border_endy);
            brush.cxt.stroke();
            // 对拼接的斜角进行绘制图像
            if (starty % border_heiht < show_border_height && draw_angle == true)
            {
                let y_offset = 5;
                // 第一条线
                border_startx = parseInt((startx + show_border_width) / border_width) * border_width * brush.size;
                border_starty = (starty + y_offset) * brush.size;
                border_endx = ((parseInt((startx + show_border_width) / border_width) ) * border_width + 1) * brush.size;
                border_endy = (starty + y_offset - 1) * brush.size;
                brush.cxt.moveTo(border_startx, border_starty);
                brush.cxt.lineTo(border_endx, border_endy);
                brush.cxt.stroke();
                // 第二条线
                border_startx = border_endx;
                border_starty = border_endy;
                border_endx = ((parseInt((startx + show_border_width) / border_width) ) * border_width + 1) * brush.size;
                border_endy = (starty + y_offset + 3) * brush.size;
                brush.cxt.moveTo(border_startx, border_starty);
                brush.cxt.lineTo(border_endx, border_endy);
                brush.cxt.stroke();
                // 第三条线
                border_startx = border_endx;
                border_starty = border_endy;
                border_endx = (parseInt((startx + show_border_width) / border_width)) * border_width * brush.size;
                border_endy = (starty + y_offset + 2) * brush.size;
                brush.cxt.moveTo(border_startx, border_starty);
                brush.cxt.lineTo(border_endx, border_endy);
                brush.cxt.stroke();

            }
            // 下斜角

            if (starty % border_heiht == 16 && starty % border_heiht < 25 && draw_angle == true)
            {
                let y_offset = 5;
                // 第一条线
                border_startx = parseInt((startx + show_border_width) / border_width) * border_width * brush.size;
                border_starty = (starty + y_offset) * brush.size;
                border_endx = ((parseInt((startx + show_border_width) / border_width) ) * border_width + 1) * brush.size;
                border_endy = (starty + y_offset - 1) * brush.size;
                brush.cxt.moveTo(border_startx, border_starty);
                brush.cxt.lineTo(border_endx, border_endy);
                brush.cxt.stroke();
                // 第二条线
                border_startx = border_endx;
                border_starty = border_endy;
                border_endx = ((parseInt((startx + show_border_width) / border_width) ) * border_width + 1) * brush.size;
                border_endy = (starty + y_offset + 3) * brush.size;
                brush.cxt.moveTo(border_startx, border_starty);
                brush.cxt.lineTo(border_endx, border_endy);
                brush.cxt.stroke();
                // 第三条线
                border_startx = border_endx;
                border_starty = border_endy;
                border_endx = (parseInt((startx + show_border_width) / border_width)) * border_width * brush.size;
                border_endy = (starty + y_offset + 2) * brush.size;
                brush.cxt.moveTo(border_startx, border_starty);
                brush.cxt.lineTo(border_endx, border_endy);
                brush.cxt.stroke();

            }
        } 

        // 绘制横向边框
        if ((starty + show_border_height) / border_heiht >= 1 && (starty + show_border_height) % border_heiht < show_border_height)
        {
            let border_startx = startx * brush.size;
            let border_starty = parseInt((starty + show_border_height) / border_heiht) * border_heiht * brush.size;
            let border_endx = (startx + xCount) * brush.size;
            let border_endy = border_starty;

            brush.cxt.strokeStyle = 'hotpink';
            brush.cxt.moveTo(border_startx, border_starty);
            brush.cxt.lineTo(border_endx, border_endy);
            brush.cxt.stroke();

            // 对拼接的斜角进行绘制图像
            if (startx % border_width < show_border_width && draw_angle == true)
            {
                let x_offset = 5;
                // 第一条线
                border_startx = (startx + x_offset) * brush.size;
                border_starty = parseInt((starty + show_border_height) / border_heiht) * border_heiht * brush.size;
                border_endx = (startx + x_offset - 1) * brush.size;
                border_endy = ((parseInt((starty + show_border_height) / border_heiht) ) * border_heiht + 1) * brush.size;
                brush.cxt.moveTo(border_startx, border_starty);
                brush.cxt.lineTo(border_endx, border_endy);
                brush.cxt.stroke();
                // 第二条线
                border_startx = border_endx;
                border_starty = border_endy;
                border_endx = (startx + x_offset + 3) * brush.size;
                border_endy = ((parseInt((starty + show_border_height) / border_heiht) ) * border_heiht + 1) * brush.size;
                brush.cxt.moveTo(border_startx, border_starty);
                brush.cxt.lineTo(border_endx, border_endy);
                brush.cxt.stroke();
                // 第三条线
                border_startx = border_endx;
                border_starty = border_endy;
                border_endx = (startx + x_offset + 2) * brush.size;
                border_endy = (parseInt((starty + show_border_height) / border_heiht)) * border_heiht * brush.size;
                brush.cxt.moveTo(border_startx, border_starty);
                brush.cxt.lineTo(border_endx, border_endy);
                brush.cxt.stroke();
                
            }
            // 下斜角
            if (startx % border_width == 16 && startx % border_width < 25 && draw_angle == true)
            {
                let x_offset = 5;
                // 第一条线
                border_startx = (startx + x_offset) * brush.size;
                border_starty = parseInt((starty + show_border_height) / border_heiht) * border_heiht * brush.size;
                border_endx = (startx + x_offset - 1) * brush.size;
                border_endy = ((parseInt((starty + show_border_height) / border_heiht) ) * border_heiht + 1) * brush.size;
                brush.cxt.moveTo(border_startx, border_starty);
                brush.cxt.lineTo(border_endx, border_endy);
                brush.cxt.stroke();
                // 第二条线
                border_startx = border_endx;
                border_starty = border_endy;
                border_endx = (startx + x_offset + 3) * brush.size;
                border_endy = ((parseInt((starty + show_border_height) / border_heiht) ) * border_heiht + 1) * brush.size;
                brush.cxt.moveTo(border_startx, border_starty);
                brush.cxt.lineTo(border_endx, border_endy);
                brush.cxt.stroke();
                // 第三条线
                border_startx = border_endx;
                border_starty = border_endy;
                border_endx = (startx + x_offset + 2) * brush.size;
                border_endy = (parseInt((starty + show_border_height) / border_heiht)) * border_heiht * brush.size;
                brush.cxt.moveTo(border_startx, border_starty);
                brush.cxt.lineTo(border_endx, border_endy);
                brush.cxt.stroke();
                
            }
        }

        // 绘制最外围边框
        if (startx == 0)
        {
            let border_startx = startx * brush.size + 1;
            let border_starty = starty * brush.size;
            let border_endx = (startx) * brush.size + 1;
            let border_endy = (starty + yCount) * brush.size;

            // brush.cxt.lineWidth = 3;
            brush.cxt.strokeStyle = 'hotpink';
            brush.cxt.moveTo(border_startx, border_starty);
            brush.cxt.lineTo(border_endx, border_endy);
            brush.cxt.stroke();

        }
        if (starty == 0)
        {
            let border_startx = startx * brush.size;
            let border_starty = starty * brush.size + 1;
            let border_endx = (startx + xCount) * brush.size;
            let border_endy = (starty) * brush.size + 1;

            brush.cxt.strokeStyle = 'hotpink';
            brush.cxt.moveTo(border_startx, border_starty);
            brush.cxt.lineTo(border_endx, border_endy);
            brush.cxt.stroke();
        }
    }

    //获取下一个索引
    function getButIndex(buildControl, isNext) {
        var index = buildControl.buildIndex;
        var buildOrder = buildControl.pixelData.buildOrder;
        var newIndex = buildOrder.indexOf(index);
        return isNext ? buildOrder[newIndex + 1] : buildOrder[newIndex - 1];

    }
    //是否在同一区域(临时处理)
    function inCurrentArea(buildControl, startx, starty) {

        var pixelData = buildControl.pixelData;
        var width = pixelData.width / pixelData.widthchunk;
        var height = pixelData.height / pixelData.heightchunk;
        var areaWidth = 8;//小板宽高
        var areaHeight = 8;
        //范围的最大最小坐标
        var area = {
            minX: parseInt(startx / areaWidth) * areaWidth,
            minY: parseInt(starty / areaHeight) * areaHeight,
        }
        area.maxX = area.minX + areaWidth;
        area.maxY = area.minY + areaHeight;
        //当前坐标  
        var index = buildControl.buildIndex;
        var x = index % pixelData.widthchunk * width;
        var y = parseInt(index / pixelData.widthchunk) * height;
        if (x >= area.minX && x < area.maxX && y >= area.minY && y < area.maxY) {
            return true;
        }
        return false;
    }

    // 判断是否为多个底板
    function useMultiBoard(buildControl) 
    {
        let pixelData = buildControl.pixelData;
        let width = pixelData.width;
        let height = pixelData.height;
        
        let max = Math.max(width, height);

        // 宽和高和底板的宽高相等则不是多个底板
        if (width == buildControl.board_width && height == buildControl.board_height)
        {
            return false;
        }

        if (max <= buildControl.board_width && max <= buildControl.board_height)
        {
            return false;
        }
        else
        {
            return true;
        }
       
    }


    //#region ---------------------------------------------将数据标准化
    var formatPixelData = async function (pixelData) {

        if (!pixelData.isStandardFormat) {
            pixelData.isStandardFormat = true;
            //添加坐标轴, 用来表示横坐标和纵坐标的数字
            if (pixelData.heightchunk > 10 || pixelData.widthchunk > 10) {
                addAxis(pixelData);
            }
            //添加边框
            setBorder(pixelData);
            //添加拼装顺序
            addBuildOrder(pixelData);
            //将颜色进行排序
            sortColor(pixelData);
        }
        else {
            //防止用户缓存出错
            if (!pixelData.buildOrder) {
                //添加拼装顺序
                addBuildOrder(pixelData);
            }
        }
        //动态生成Img(将rgb转换为img)
        await particelObj.createImgForData(pixelData);
    }
    //添加坐标轴信息
    var addAxis = function (pixelData) {
        var axisType = pixelData.width > pixelData.height ? "left-top" : "left-bottom";
        var image = pixelData.image;
        //根据区域块的大小设置宽高
        var width = image[0].width;
        var height = image[0].height;
        var offsetX = image[0].startx;
        var offsetY = image[0].starty;
        pixelData.axis = {
            type: axisType,
            width: width,
            height: height,
            xlegend: [],
            ylegend: [],
        }
        //设置legend
        if (axisType == "left-bottom") {
            for (var i = 0; i < pixelData.widthchunk; i++) {
                pixelData.axis.xlegend.push(String.fromCharCode(65 + i));
            }
            for (var i = 0; i < pixelData.heightchunk; i++) {
                pixelData.axis.ylegend.push(i + 1);
            }
        }
        else if (axisType == "left-top") {
            for (var i = 0; i < pixelData.widthchunk; i++) {
                pixelData.axis.xlegend.push(i + 1);
            }
            for (var i = 0; i < pixelData.heightchunk; i++) {
                pixelData.axis.ylegend.push(String.fromCharCode(65 + i));
            }
        }

        //根据不同坐标类型调整偏移量
        for (var i = 0; i < image.length; i++) {
            var part = image[i];
            if (axisType == "left-bottom") {
                part.startx = part.startx - offsetX + width;
                part.starty = part.starty - offsetY;
            }
            else if (axisType == "left-top") {
                part.startx = part.startx - offsetX + width;
                part.starty = part.starty - offsetY + height;
            }
            else {
                //没有坐标轴
                part.startx = part.startx - offsetX;
                part.starty = part.starty - offsetY;
                pixelData.axis.width = 0;
                pixelData.axis.height = 0;
            }
        }
    }
    //添加拼装顺序
    var addBuildOrder = function (pixelData) {
        var length = pixelData.widthchunk * pixelData.heightchunk;
        //定义拼装顺序
        // 针对不同板式，添加拼装顺序
        
        // 
        // 分块块的原始顺序为：0, 1,  2,  3,  4,  5,  6, 7, 
        //                  8, 9, 10, 11, 12, 13, 14, 15, 
        //                  *****************
        //                  56, 57, 58, 59, 60, 61, 62, 63 
        // 排序时，先两排组成一组。这个组中，再按从左到右的顺序，四块组成一个子组。子组中，从上到下，依次为：0, 1, 2, 3
        // 排序后的顺序为：0, 1, 8, 9, 2, 3, 10, 11, 4, 5, 12, 13, 6, 7, 14, 15,
        
        let height_chunk = pixelData.heightchunk;
        let width_chunk = pixelData.widthchunk;
        let height_chunk2 = Math.ceil(height_chunk / 2);
        let width_chunk2 = Math.ceil(width_chunk / 2);

        pixelData.buildOrder = [];

        // for (let i = 0; i < height_chunk2; i++) {
        //     for (let j = 0; j < width_chunk2; j++) {
        //         pixelData.buildOrder.push((i * width_chunk + j) * 2);
        //         pixelData.buildOrder.push((i * width_chunk + j) * 2 + 1);
        //         pixelData.buildOrder.push((i * width_chunk + j) * 2 + width_chunk);
        //         pixelData.buildOrder.push((i * width_chunk + j) * 2 + 1 + width_chunk);
        //     }
        // }

        for (let i = 0; i < height_chunk; i++) {
            for (let j = 0; j < width_chunk; j++) {
                pixelData.buildOrder.push(i * width_chunk + j);
            }
        }

    }
    //对颗粒进行排序
    var sortColor = function (pixelData) {
        var color = pixelData.color;
        color.sort((a, b) => a.usednum > b.usednum ? -1 : 1);
    }
    //设置边框边框(标记为-1)
    function setBorder(pixelData) {
        var length = pixelData.widthchunk * pixelData.heightchunk;
        if (length == 36) {
            var image = pixelData.image;
            //最上边
            for (var i = 0; i < pixelData.widthchunk; i++) {
                for (var j = 0; j < image[i].width; j++) {
                    image[i].data[j] = -1;
                }
            }
            //最下边
            for (var i = pixelData.image.length - pixelData.widthchunk; i < pixelData.image.length; i++) {
                for (var j = image[i].data.length - image[i].width; j < image[i].data.length; j++) {
                    image[i].data[j] = -1;
                }
            }
            //最左边
            for (var i = 0; i < pixelData.heightchunk; i++) {
                var chunk = image[i * pixelData.widthchunk];
                for (var j = 0; j < chunk.height; j++) {
                    chunk.data[j * chunk.width] = -1;
                }
            }
            //最右边
            for (var i = 0; i < pixelData.heightchunk; i++) {
                var chunk = image[i * pixelData.widthchunk + pixelData.widthchunk - 1];
                for (var j = 0; j < chunk.height; j++) {
                    chunk.data[j * chunk.width + chunk.width - 1] = -1;
                }
            }
        }

    }
    //#endregion-----------------------------------------------------


    //#region ----------------------------------颗粒图（动态生成）
    var particelObj = {
        particelImgs: [],//颗粒列表
        particelWidth: 128,//颗粒宽
        particelHeight: 128,//颗粒高        
        whiteParticel: new Image(),//白色颗粒的底图
        blackParticel: new Image(),//黑色颗粒的底图
        canvas: undefined,//绘制颗粒的画布
        cxt: undefined,//绘制颗粒的上下文
        init: function (whiteSrc, blackSrc) {
            this.canvas = document.createElement('canvas');
            this.canvas.width = this.particelWidth;
            this.canvas.height = this.particelHeight;
            this.cxt = this.canvas.getContext('2d');
            this.cxt.willReadFrequently = true;
            if (!whiteSrc) {
                this.cxt.fillStyle = 'rgb(255, 255, 255)';
                this.cxt.fillRect(0, 0, this.particelWidth, this.particelHeight);
                whiteSrc = this.canvas.toDataURL();
            }
            if (!blackSrc) {
                this.cxt.fillStyle = 'rgb(0, 0, 0)'
                this.cxt.fillRect(0, 0, this.particelWidth, this.particelHeight);
                blackSrc = this.canvas.toDataURL();
            }
            this.whiteParticel.src = whiteSrc;
            this.blackParticel.src = blackSrc;
        },
        getParticel: function (rgb, callback) {
            //亮度
            var lightness = 1;
            //先判断缓存里面有没有
            var img = undefined;
            for (var i = 0; i < this.particelImgs.length; i++) {
                if (rgb[0] == this.particelImgs[i].rgb[0] && rgb[1] == this.particelImgs[i].rgb[1] && rgb[2] == this.particelImgs[i].rgb[2]) {
                    img = this.particelImgs[i].img;
                    if (img.complete) {
                        callback(img)
                    }
                    else {
                        img.addEventListener("load", function () {
                            callback(img);
                        })
                    }
                    return;
                }
            }
            //先清空画布
            this.cxt.clearRect(0, 0, this.particelWidth, this.particelHeight);
            if (rgb[0] < 30 && rgb[1] < 30 && rgb[2] < 30) {
                //黑色没法混合计算，单独处理
                this.cxt.drawImage(this.blackParticel, 0, 0, this.particelWidth, this.particelHeight);
            }
            else {
                //先获取用来混合计算的原始数据（也就是白色底图）         
                this.cxt.drawImage(this.whiteParticel, 0, 0, this.particelWidth, this.particelHeight);
                var whiteData = this.cxt.getImageData(0, 0, this.particelWidth, this.particelHeight)
                //混合计算
                for (var i = 0; i < whiteData.data.length; i += 4) {
                    var r, g, b;
                    if (whiteData.data[i + 3] == 0) {
                        r = rgb[0];
                        g = rgb[1];
                        b = rgb[2];
                    }
                    else {
                        whiteData.data[i] = rgb[0] * whiteData.data[i] / 255 * lightness;
                        whiteData.data[i + 1] = rgb[1] * whiteData.data[i + 1] / 255 * lightness;
                        whiteData.data[i + 2] = rgb[2] * whiteData.data[i + 2] / 255 * lightness;
                    }
                }
                this.cxt.putImageData(whiteData, 0, 0);
            }
            var img_url = this.canvas.toDataURL();
            img = new Image()
            img.src = img_url;
            var imgObj = {
                rgb: [rgb[0], rgb[1], rgb[2]],
                img: img,
                state: "loading"
            }
            this.particelImgs.push(imgObj);
            img.addEventListener("load", function () {
                callback(img);
            })
        },
        createImgForData: function (pixelData) {
            var self = this;
            return new Promise(function (resolve, reject) {
                if (pixelData != undefined) {
                    //初始化图像需要等待所有图片加载完成
                    var imageCount = pixelData.color.length;
                    for (var i = 0; i < pixelData.color.length; i++) {
                        var cb = function (item) {
                            return function (img) {
                                item.img = img;
                                imageCount--;
                                if (imageCount <= 0) {
                                    //保证所有图片都load完成
                                    resolve();
                                }
                            }
                        }
                        self.getParticel(pixelData.color[i].rgb, cb(pixelData.color[i]));
                    }
                }
            })
        }
    }
    //#endregion-----------------------------------------------------


    //#region ----------------------------------mini指示图
    let miniMap = {
        canvas: undefined,//绘制miniMap的画布
        cxt: undefined,//绘制miniMap的上下文
        particelSize: 3,//颗粒大小，表示清晰度
        img: undefined,//显示的图
        space_top : 2,   //上边距,单位百分比
        init: function (imgContainer, build) {

            // console.log("init miniMap canvas");
            // console.dir(this.canvas);
            // console.dir(this.img);

            if (true == debugswitch)
            {
                console.log("create miniMap imgContainer ");
                console.dir(imgContainer);
                let secondswiper = document.querySelector('#swiper-second')
                console.dir(secondswiper);
                let premode_swiper = document.querySelector('#premodel_swiper')
                console.dir(premode_swiper);
                let premodel_swipercontainer = document.querySelector('#premode_swipercontainer')
                console.dir(premodel_swipercontainer);
                let app_container = document.querySelector('#app-container')
                let app_container_height = app_container.clientHeight;
                let build_scene = document.getElementById("build_scene");
                let build_scene_height = build_scene.clientHeight;

                alert("init miniMap imgContainer height :" + imgContainer.clientHeight + " app container height :" + app_container_height + " documentElement height :" + document.documentElement.clientHeight + " build_scene height :" + build_scene_height);
            }

            if (this.img != undefined)
            {
                //清空图片
                this.img.src = "";
                this.img.remove();
            }
            if (this.canvas != undefined)
            {
                this.canvas.remove();
                this.canvas = undefined;
            }

            if (this.canvas == undefined)
            {

                //画布
                this.canvas = document.createElement('canvas');
                this.cxt = this.canvas.getContext('2d');
                
                //图片（这里改用图片是因为画布的最小单位为1像素，无法调整布局）
                this.img = document.createElement('img');
                imgContainer.appendChild(this.img);

                if (debugswitch == true)
                {
                    console.dir(this.cxt);
                }
                
            }

            // this.cxt.clearRect(0, 0, this.cxt.width, this.cxt.height);

            if (build.minimapParticelSize) {
                this.particelSize = build.minimapParticelSize;
            }
            //坐标轴
            var axis = build.pixelData.axis || { width: 0, height: 0 };
            //设置画布宽高
            this.canvas.width = this.particelSize * (build.pixelData.width + axis.width);
            this.canvas.height = this.particelSize * (build.pixelData.height + axis.height);
            //根据容器大小调整图片大小

            // let clientwidth = imgContainer.clientWidth > 0 ? imgContainer.clientWidth : document.body.clientWidth;
            // let clientheight = imgContainer.clientHeight > 0 ? imgContainer.clientHeight : document.body.clientHeight;
            let clientwidth = imgContainer.clientWidth > 0 ? imgContainer.clientWidth : document.documentElement.clientWidth;
            let clientheight = imgContainer.clientHeight > 0 ? imgContainer.clientHeight : document.documentElement.clientHeight * 0.46;

            var widthScale = this.canvas.width / clientwidth;
            var heightScale = this.canvas.height / clientheight;

            // this.canvas.top = (this.space_top / 100) * clientheight + "px";

            // 如下注释关注数值变化，不需要删除，后期可能会用到
            // console.log("init miniMap");
            // console.log(widthScale, heightScale, imgContainer.clientWidth, imgContainer.clientHeight);
            // // console.dir("imgcontainer offset top:" + imgContainer.offsetTop + " offset left:" + imgContainer.offsetLeft);
            // console.log("init miniMap canvas width:" + this.canvas.width + " height:" + this.canvas.height);
            // // console.dir("window width:" + window.innerWidth + " height:" + window.innerHeight);
            // console.dir("document clientwidth:" + document.body.clientWidth + " client height:" + document.body.clientHeight);
            // console.dir("document offset width:" + document.body.offsetWidth + " offset height:" + document.body.offsetHeight);
            // // console.dir("window screen width:" + window.screen.width + " screen height:" + window.screen.height);
            // console.dir("document element width:" + document.documentElement.clientWidth + " height:" + document.documentElement.clientHeight);
            // console.dir("imgcontainer " + imgContainer.style);
            // console.dir("imgcontainer width " + imgContainer.style.width + " height " + imgContainer.style.height);
            

            var scale = Math.max(widthScale, heightScale);
 
            this.img.width = this.canvas.width / scale;
            this.img.height = this.canvas.height / scale;

            // 如下alert在调试ios等不能模拟的情况下有效
            // alert("init miniMap imgContainer height :" + imgContainer.clientHeight + " width :" + imgContainer.clientWidth +
            //     " documentElement height :" + document.documentElement.clientHeight + " width :" + document.documentElement.clientWidth + " image height :" + this.img.height + " width :" + this.img.width + " height scale :" + heightScale + " width scale :" + widthScale + " scale :" + scale);

            //绑定点击事件
            var self = this;
            self.img.onclick = function (e) {
                //是否有坐标轴
                var axischunk = axis.type == "left-top" || axis.type == "left-bottom" ? 1 : 0;
                var x = e.offsetX, y = e.offsetY;
                var row_count = build.pixelData.heightchunk + axischunk;
                var column_count = build.pixelData.widthchunk + axischunk;
                var row_index = parseInt(y / self.img.height * row_count);
                var column_index = parseInt(x / self.img.width * column_count);
                //没有坐标轴算出的索引
                var index = row_index * column_count + column_index;
                // console.log("row_index:"+row_index+",column_count: "+column_count);   
                //根据坐标轴类型重新计算偏移
                if (row_index >= row_count || column_index >= column_count) {
                    //这里不知道为什么，在图片边缘外，明显没点中，却触发click事件
                    return;
                }
                //计算当前位置
                var xIndex = parseInt(build.buildIndex % build.pixelData.widthchunk);
                var yIndex = parseInt(build.buildIndex / build.pixelData.widthchunk);
                if (axis && axis.type) {
                    if (axis.type == "left-top") {
                        if (column_index == 0 && row_index == 0) {
                            //点击到x轴和y轴交叠地方(不需要处理)
                            return;
                        }
                        if (column_index == 0) {
                            //点击到Y轴上
                            index = row_index * (column_count - 1) + xIndex - column_count + 1;
                        }
                        else if (row_index == 0) {
                            //点击到X轴上
                            index = yIndex * (column_count - 1) + column_index - 1;
                        }
                        else {
                            //点击到图像上                   
                            index -= (row_index + column_count);
                        }
                    }
                    else if (axis.type == "left-bottom") {
                        if (column_index == 0 && row_index == row_count - 1) {
                            //点击到x轴和y轴交叠地方(不需要处理)
                            return;
                        }
                        if (column_index == 0) {
                            //点击到Y轴上
                            index = row_index * (column_count - 1) + xIndex;
                        }
                        else if (row_index == row_count - 1) {
                            //点击到X轴上
                            index = yIndex * (column_count - 1) + column_index - 1;
                        }
                        else {
                            //点击到图像上                       
                            index -= (row_index + 1);
                        }
                    }
                }
                else {
                    index = row_index * column_count + column_index;
                }
                build.drawMinimapImage(index);
                aniObj.drawCurrentPart();
                //隐藏提示框
                if (build.clickAlert != undefined) {
                    build.clickAlert.hide();
                }
            }

            //绘制当前索引
            build.drawMinimapImage(build.buildIndex);
        },
        //绘制图片
        drawImg: function (buildControl, pixelData, index, byStep) {

            //默认全部更新
            var start = 0;
            var end = pixelData.image.length;
            if (byStep) {
                //点击上一步或者下一步，计算更新区域（并不是整个画面全部更新，节省性能）
                start = index - 1 >= 0 ? index - 1 : 0;
                end = index + 2 <= pixelData.image.length ? index + 2 : pixelData.image.length;
            }
            var brush = {
                cxt: this.cxt,
                size: this.particelSize,
            };
            var order = pixelData.buildOrder;

            if (debugswitch == true)
            {
                console.log("drawImg index:" + index + " byStep:" + byStep + " start:" + start + " end:" + end);
                console.dir(this.cxt);
                console.log("drawImg pixelData.width %d height %d, canvas width %d height %d", 
                        pixelData.width, pixelData.height, this.cxt.width, this.cxt.height);
                console.dir(this.canvas);
            }
            
            
            // 如下细节很重要，必须先将画笔beginPath，否则清空将不起作用
            brush.cxt.beginPath();
            brush.cxt.clearRect(0, 0, this.canvas.width, this.canvas.height);

            for (var i = start; i < end; i++) {
                if (order.indexOf(i) < order.indexOf(index)) {
                    drawPart(buildControl, { colorIndexs: pixelData.image[i], colorMap: pixelData.color }, brush, { isChild: true });
                }
                else if (order.indexOf(i) == order.indexOf(index)) {
                    drawPart(buildControl, { colorIndexs: pixelData.image[i], colorMap: pixelData.color }, brush, { isChild: true, prominent: true });
                }
                else {
                    drawPart(buildControl, { colorIndexs: pixelData.image[i], colorMap: pixelData.color }, brush, { isChild: true, mask: true });
                }
            }
            //更新坐标信息
            if (pixelData.axis) {
                this.updateCoordinate(pixelData.axis, index);
            }
            //转为图片
            var img_url = this.canvas.toDataURL();
            
            this.img.src = img_url;

        },
        //更新坐标信息, 在左边和上边框上显示当前位置的坐标
        updateCoordinate: function (axis, index) {
            //占用宽高
            var width = axis.width * this.particelSize;
            var height = axis.height * this.particelSize;
            var fontSize = Math.min(width, height) * 3 / 4;
            //起始位置
            var horizontalAxisStartX = 0;
            var horizontalAxisStartY = 0;
            var verticalAxisStartX = 0;
            var verticalAxisStartY = 0;
            if (axis.type == "left-top") {
                horizontalAxisStartX = 1 * width;
                verticalAxisStartY = 1 * height;
            }
            else if (axis.type == "left-bottom") {
                horizontalAxisStartX = 1 * width;
                horizontalAxisStartY = axis.ylegend.length * width;
            }
            else {
                //没有坐标轴
                return;
            }
            //计算当前位置
            var xIndex = parseInt(index % axis.xlegend.length);
            var yIndex = parseInt(index / axis.xlegend.length);
            //horizontal轴
            for (var i = 0; i < axis.xlegend.length; i++) {
                var posx = horizontalAxisStartX + i * width;
                var posy = horizontalAxisStartY;
                //清空
                this.cxt.clearRect(posx, posy, width, height);
                this.cxt.font = fontSize + "px 隶书";
                if (i == xIndex) {
                    // this.cxt.fillStyle = 'rgba(0, 255, 0, 1)';
                    this.cxt.fillStyle = 'rgba(255, 0, 0, 1)';
                }
                else {
                    // this.cxt.fillStyle = 'rgba(255, 255, 255, 1)';
                    this.cxt.fillStyle = 'rgba(0, 0, 255, 1)';
                }
                this.cxt.textAlign = "center";
                this.cxt.textBaseline = "middle";
                // 填写边框的坐标信息
                this.cxt.fillText(axis.xlegend[i], posx + width / 2, posy + height / 2);
            }
            //vertical轴
            for (var i = 0; i < axis.ylegend.length; i++) {
                var posx = verticalAxisStartX;
                var posy = verticalAxisStartY + i * width;
                //清空
                this.cxt.clearRect(posx, posy, width, height);
                this.cxt.font = fontSize + "px 隶书";
                if (i == yIndex) {
                    // this.cxt.fillStyle = 'rgba(0, 255, 0, 1)';
                    this.cxt.fillStyle = 'rgba(255, 0, 0, 1)';
                }
                else {
                    // this.cxt.fillStyle = 'rgba(255, 255, 255, 1)';
                    this.cxt.fillStyle = 'rgba(0, 0, 255, 1)';
                }
                this.cxt.textAlign = "center";
                this.cxt.textBaseline = "middle";
                this.cxt.fillText(axis.ylegend[i], posx + width / 2, posy + height / 2);
            }
        }
    }
    //#endregion-----------------------------------------------------

    var test_aniobj = {
        init: function (container) {
            console.log("~~~~+++++++++ init test aniObj input build");
            console.dir("height " + container.clientHeight);
            console.dir("width " + container.clientWidth);
            console.dir(container);
            let parent = container.parentElement;
            console.dir(parent);
            // let buildpart_anit = document.querySelector('#build_part_ani')
            // console.dir(buildpart_anit);
            // let part_container = document.querySelector('#part_container')
            // console.dir(part_container);
            // let buildpart_anit_parent = buildpart_anit.parentElement;
            // console.dir(buildpart_anit_parent);
        }
    }


    //#region ----------------------------------上一步,下一步过渡动画
    var aniObj = {
        space: 20,   //两个画布之间的间隔
        fps: 30, //动画帧率
        playSpeed: 0.8, //平均法，需要的总时间
        isplaying: false,        //是否正在播放
        currentAniPart: undefined,    //当前显示的画布 
        firstAnimationPart : undefined, //第一个画布, 正常来说第一个画布是完整画布，不会有缺失颗粒的情况
        particelSize: 64,    //颗粒尺寸          
        item1: undefined,    //画布1
        item2: undefined,    //画布2
        build: undefined,
        init: function (container, build) {


            if (true == debugswitch)
            {
                // console.log("~~~~+++++++++ init aniObj");
                // console.dir(this.build);
                console.log("~~~~+++++++++ init aniObj input build");
                // console.dir(build);
                console.dir("height " + container.clientHeight);
                console.dir("width " + container.clientWidth);
                let buildpart_anit = document.querySelector('#build_part_ani')
                console.dir(buildpart_anit);
                let part_container = document.querySelector('#part_container')
                console.dir(part_container);
                var buildpart_anit_parent = buildpart_anit.parentElement;
                console.dir(buildpart_anit_parent);
            }
            

            if (this.build != undefined)
            {
                if (this.build.originalImage != build.originalImage)
                {
                    container.innerHTML = ""; 
                    // container.innerHTML = "";
                    if (this.item1 != undefined)
                    {
                        this.item1.remove();
                    }
                    if (this.item2 != undefined)
                    {
                        this.item2.remove();
                    }
                    this.build = undefined;
                    
                }
            }

            if (!this.build) {
                //拿到build引用
                this.build = build;

                if (debugswitch == true)
                {
                    console.log("init aniObj part container");
                    console.dir("before part container width " + container.style.width + " height " + container.style.height);
                    console.dir("height " + container.clientHeight);
                    console.dir("width " + container.clientWidth);
                }

                //创建画布
                this.item1 = document.createElement('canvas');
                this.item2 = document.createElement('canvas');
                container.appendChild(this.item1);
                container.appendChild(this.item2);

                let clientHeight = container.clientHeight;
                // if (clientHeight == 0)
                // {
                //     clientHeight = parseInt(buildpart_anit_parent.clientHeight * 0.5);
                // }

                //根据容器大小调整画布大小(布局)
                var canvasWidth = this.particelSize * build.pixelData.image[0].width;
                var canvasHeight = this.particelSize * build.pixelData.image[0].height;
                var widthScale = canvasWidth / (container.clientWidth - this.space);
                var heightScale = canvasHeight / (clientHeight - this.space);

                if (debugswitch == true)
                {
                    console.dir("height " + clientHeight);
                    console.dir("width " + container.clientWidth);
                    console.dir("canvasWidth " + canvasWidth + " canvasHeight " + canvasHeight);
                    console.dir("widthScale " + widthScale + " heightScale " + heightScale);
                }
                

                var scale = Math.max(widthScale, heightScale);
                this.item1.width = canvasWidth / scale;
                this.item1.height = canvasHeight / scale;
                this.item2.width = this.item1.width;
                this.item2.height = this.item1.height;
                this.item1.style['position'] = "absolute";
                this.item2.style['position'] = "absolute";
                //调整container大小
                container.style.width = (this.item1.width + this.space) + "px";
                container.style.height = (this.item1.height + this.space) + "px";

                if (debugswitch == true)
                {
                    console.dir("part container width " + container.style.width + " height " + container.style.height);
                    console.dir("part container clientWidth " + container.clientWidth + " clientHeight " + clientHeight);
                }
                


                this.item1.style.top = this.space / 2 + "px";
                this.item2.style.top = this.space / 2 + "px";
                this.item1.style.left = this.space / 2 + "px";
                this.item2.style.left = container.style.width;
                //设置画布的缩放
                this.item1.getContext("2d").scale(1 / scale, 1 / scale);
                this.item2.getContext("2d").scale(1 / scale, 1 / scale);
                //设置初始画布
                this.currentAniPart = this.item1;
                this.firstAnimationPart = this.item1;
            }
            //绘制当前部位
            this.drawCurrentPart();
        },
        play: function (clip) {
            var self = this;
            //ani1是即将出现的canvas，ani2是当前显示的canvas
            var ani1, ani2;
            if (this.currentAniPart === self.item1) {
                ani1 = self.item2;
                ani2 = self.item1;
            }
            else {
                ani1 = self.item1;
                ani2 = self.item2;
            }
            self.currentAniPart = ani1;
            self.drawCurrentPart();
            var moveDir = 0;
            if (clip == "prev") {
                ani1.style.left = (ani1.width + self.space * 2) + "px";
                moveDir = -1;
            }
            else {
                ani1.style.left = -(ani1.width + self.space) + "px";
                moveDir = 1;
            }
            var targetX = self.space / 2;
            self.isplaying = true;
            var dis = Math.abs(targetX - parseFloat(ani1.style.left));
            var moveSpeed = dis / (self.playSpeed * self.fps) * moveDir;
            function update() {

                dis = targetX - parseFloat(ani1.style.left);
                if (Math.abs(dis) > Math.abs(moveSpeed)) {
                    ani1.style.left = (parseFloat(ani1.style.left) + moveSpeed) + "px";
                    ani2.style.left = (parseFloat(ani2.style.left) + moveSpeed) + "px";
                    setTimeout(update, 1 / self.fps);
                }
                else {
                    ani1.style.left = parseFloat(ani1.style.left) + dis + "px";
                    ani2.style.left = parseFloat(ani2.style.left) + dis + "px";
                    self.isplaying = false;
                }
            }
            update();

        },
        drawCurrentPart: function () {
            //当前部位
            var part = this.build.pixelData.image[this.build.buildIndex];
            var brush = {
                cxt: this.currentAniPart.getContext("2d"),
                size: this.particelSize,
            }

            // console.log("drawCurrentPart currentAniPart width " + this.currentAniPart.width + " height " + this.currentAniPart.height);
            // console.log("drawCurrentPart firstAnimationPart width " + 
            //             this.firstAnimationPart.width + " height " + this.firstAnimationPart.height);
            
            //这里清除画布的方法有问题，使用firstAnimationPart的宽高并不能将画布清干净，只能放大10后，再清空，保证足够大的面积清理
            brush.cxt.beginPath();
            brush.cxt.clearRect(0, 0, this.currentAniPart.width * 10, this.currentAniPart.height * 10);

            drawPart(this.build, { colorIndexs: part, colorMap: this.build.pixelData.color }, brush, { isChild: false });
        }
    }
    //#endregion-----------------------------------------------------
    return Build;
})();

